import { HiPencil } from "react-icons/hi2";

export const EditIcon = ({ width, height, color, ...props }) => (
  <HiPencil
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
